import * as Ably from 'ably'

const configuredAuthUrl = process.env.REACT_APP_ABLY_AUTH_URL || '/api/ably-auth'
const isLocalhost = typeof window !== 'undefined' && window.location.hostname === 'localhost'

const ably = new Ably.Realtime({
  authUrl: isLocalhost ? '/api/ably-auth' : configuredAuthUrl,
})

export default ably
